import { hasPermissionGuard } from "../../core/guards";
import { Constants } from "../../shared/constants/constants";
import { PermissionAction } from "../../shared/constants/enums";

export const viewGovDirectionsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.view,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.GOVERNMENT_DIRECTIONS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const createGovDirectionsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.create,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.GOVERNMENT_DIRECTIONS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];

export const manageGovDirectionsPageGuards = [
  hasPermissionGuard({
    actor: {
      modifier: "and",
      permissions: [
        {
          permissionAction: PermissionAction.manage,
          objectTypeId: Constants.CONSTANT_PERMISSIONS.GOVERNMENT_DIRECTIONS,
        },
      ],
    },
    redirectTo: "/403",
  }),
];
